import { axios } from '@vivaldis/common'

export interface CnxStartUpDocumentListItem {
  matchId: string
  employeeName: string
  positionName: string
  startDatum: string | null // Planned start date for the employee's contract
  opstartStatus: 'Initiated' | 'In Progress' | 'Completed' // Status of the start-up document
  part1Status: boolean // Is part 1 (Contract information) done?
  part2Status: boolean // Is part 2 (Additional benefits) done?
}

export interface FetchStartUpDocumentsQueryParams {
  companyID: string // companyId in connexys
  TAAL: string // en | nl | fr | string
}

export interface FetchStartUpDocumentsApiResponse {
  status: {
    message: string // 'Job application not found for id a0d3H000008XLtcQAG'
    code: string // "200" or "404" or "500"
  }
  data: CnxStartUpDocumentListItem[]
}

export const fetchStartUpDocuments = async ({
  companyID,
  TAAL
}: FetchStartUpDocumentsQueryParams) => {
  const response = await axios().get<FetchStartUpDocumentsApiResponse>(
    `/api/start_up_documents/documents`,
    {
      params: {
        companyID: companyID,
        TAAL: TAAL
      },
      data: {}
    }
  )
  return response.data.data
}
